<script setup>
import {APIService} from '@/core/util/services/api.service';
import {onBeforeMount} from 'vue';
import {inject, ref, defineProps, watch} from 'vue';
import FileInput from '../../../orangehrmPimPlugin/components/FileInput.vue';
import MultiChips from '@ohrm/oxd/core/components/Input/MultiSelect/MultiSelectChips.vue';
import debounce from '@ohrm/oxd/utils/debounce';

const $toast = inject('$toast');
const http = new APIService(window.appGlobal.baseUrl, '');
const props = defineProps({
  id: Number,
  isAssignee: Boolean,
  assigneeId: Number,
});

const isLoading = ref(false);
const qualificationForm = ref({
  status: {id: '', label: ''},
  remarks: '',
  employeeSignature: {label: '', path: ''},
});

const selectedEmployee = ref(null);
const employees = ref([]);

const isEmpty = value => {
  return value == '' || value == null || value == undefined;
};

const exportPdf = () => {
  window.open(
    `${window.appGlobal.publicPath}/api/onboarding/${props.id}/qualification_pdf`,
  );
};

const onSave = () => {

  const formData = new FormData();
  formData.append('status', qualificationForm.value.status?.id ?? null);
  formData.append('remarks', qualificationForm.value.remarks);

  if (
    qualificationForm.value.employeeSignature?.value instanceof File ||
    qualificationForm.value.employeeSignature == null
  ) {
    formData.append(
      'employee_signature',
      qualificationForm.value.employeeSignature?.value ?? null,
    );
  }

  http
    .request({
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'POST',
      url: `/api/onboarding/${props.id}/assignie/${props.assigneeId}/qualification`,
      data: formData,
    })
    .then(response => {
      $toast.saveSuccess();
    })
    .catch(error => {
      $toast.unexpectedError();
      console.error(error);
    })
    .finally(() => {
      //
    });
};

const getQualificationData = () => {
  isLoading.value = true;

  const url =
    props.isAssignee || selectedEmployee.value == null
      ? `/api/onboarding/${props.id}/qualification`
      : `/api/onboarding/${props.id}/assignie/${selectedEmployee.value?.id}/qualification`;

  http
    .request({
      method: 'GET',
      url: url,
    })
    .then(response => {
      if (!isEmpty(response.data)) qualificationForm.value = response.data;
    })
    .catch(error => {
      $toast.unexpectedError();
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const getAssignEmployees = () => {
  http
    .request({
      method: 'GET',
      url: '/api/onboarding/assignedEmployees',
      params: {onboardingId: props.id},
    })
    .then(response => {
      employees.value = response.data;
    });
};

const openFile = path => {
  window.open(`${window.appGlobal.publicPath}/${path}`, '_blank');
};

const addCoWorkerSignature = event => {
  qualificationForm.value.employeeSignature = {
    label: event.target.files[0].name ?? '',
    value: event.target.files[0],
  };
};

const removeCoWorkerSignature = () => {
  qualificationForm.value.employeeSignature = null;
};

watch(
  selectedEmployee,
  debounce(() => {
    getQualificationData();
  }, 500),
  {deep: true},
);

onBeforeMount(() => {
  getQualificationData();
  if (!props.isAssignee) {
    getAssignEmployees();
  }
});
</script>
<template>
  <div style="text-align:right">
    <oxd-button
      label="Export"
      icon-name="file-pdf"
      display-type="secondary"
      :disabled="canExport == false"
      @click="exportPdf()"
    />
  </div>
  <div class="orangehrm-background-container">
    <oxd-form :loading="isLoading" @submitValid="onSave">
      <oxd-form-row>
        <oxd-grid :cols="3" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              label="Qualification Status"
              :value="qualificationForm.status?.label"
              :disabled="true"
            />
          </oxd-grid-item>
          <oxd-grid-item class="--span-column-2">
            <oxd-input-field
              :value="qualificationForm.remarks"
              type="textarea"
              label="Remarks"
              placeholder="Remarks"
              :disabled="true"
            />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>
      <oxd-form-row>
        <oxd-grid v-if="isAssignee" :cols="2">
          <oxd-grid-item>
            <FileInput
              :disabled="qualificationForm.employeeSignature != null"
              label="Co-worker signature"
              @change="addCoWorkerSignature"
            ></FileInput>
            <MultiChips
              v-if="qualificationForm.employeeSignature != null"
              :selected="[qualificationForm.employeeSignature]"
              @chip-removed="removeCoWorkerSignature"
            />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>
      <oxd-divider />
      <oxd-form-actions>
        <submit-button />
      </oxd-form-actions>
    </oxd-form>
  </div>
</template>
